import * as Yup from "yup";

export const questionValidation = Yup.object().shape({
  description: Yup.string().required("وارد کردن توضیحات الزامی است"),
  title: Yup.string().required("وارد کردن عنوان الزامی است"),
});
